export const INSTRUCTOR_CATEGORIES = {
  primary: 'primary',
  secondary: 'secondary',
  other: 'other',
};
